import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Paper, Typography, Container, Divider, Button, Chip, Dialog, Tooltip, useMediaQuery, Box, Tabs as TabsMui, Tab, IconButton, Table, TableBody, TableCell, TableRow, TableFooter, TablePagination, CircularProgress
} from '@mui/material';
import { CheckCircleRounded, CancelRounded, AddCircleOutline, Delete as DeleteIcon } from '@mui/icons-material';
import confirm from '../../../../UI/Confirm/confirm';
import TablePaginationActionsWrapped from '../../../../UI/MaterialTableOverrides/TablePaginationActions';
import * as actions from "../../../../store/actions";
import {
  FormStyled, DivFormTitle
} from './../styles';
import Spinner from '../../../../components/Spinner/index';
import ModalEquipmentChecklist from '../../Modals/ModalEquipmentChecklist';
import Tabs from '../../../../components/Tabs/TabsEquipment';
import Timeline from '../../../../components/ServicesTimeline/index';
import { i18n } from '../../../../translate/i18n';
import { sortBy, isEmpty, orderBy as orderByLoadash } from 'lodash';
import extractPositionFromName from '../../../../utils/orderChecklist';
import { orderQuestionArray } from '../../../../utils/orderQuestionArray';
import SendIcon from '@mui/icons-material/Error';
import moment from 'moment';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { checkFeatureFlag } from '../../../../utils/checkFeatureFlag';
import ScheduleServiceModal from '../../../../components/ScheduleServiceModal';
import EFeatureFlags from '../../../../utils/EFeatureFlags';
import ButtonDropdown from '../../../../components/ButtonDropdown';
import PrintIcon from '@mui/icons-material/Print';
import { formatLanguageFromLocalStorage } from '../../../../utils/formatLanguageFromLocalStorage';
import { EAccessRole } from '../../../../store/types';
import { EDataExportsType } from '../../../../store/reducers/dataExports';
import ServiceCreationBlockedModal from '../../../../components/ServiceCreationBlockedModal';

const styles = {
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  paper: {
    position: 'relative',
    marginBottom: '1rem',
  },
  formContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 0.5rem'
  },
  title: {
    fontSize: '0.9rem',
  },
  subtitle: {
    fontSize: '0.7rem',
  },
  chipContainer: {
    padding: '0.5rem 0 0 0',
  },
  chip: {
    cursor: 'pointer',
    margin: '0.1rem',
  },
  servicesNotFound: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  loadMoreBox: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  warningIcon: {
    color: '#F4D03F',
    width: '20px',
    position: 'absolute',
    right: '15px',
    marginBottom: '15px',
  }
};


const FormEquipments = (props) => {
  const dispatch = useDispatch();
  const equipId = props.match.params.id;
  const matches = useMediaQuery('(min-width:1200px)');

  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [orderBy, setOrderBy] = useState("date");
  const [order, setOrder] = useState("desc");

  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState();

  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);

  const tenant = useSelector((state) => state.auth.selectedAccess.tenant);
  const loadingZip = useSelector((state) => state.equipments.loadingZipExport);
  const loadingSimplified = useSelector((state) => state.equipments.loadingSimplifiedExport);
  const [scheduledServiceModalOpen, setScheduledServiceModalOpen] = useState(false);
  const [serviceName, setServiceName] = useState('');
  const [equipmentServiceReplicateSelected, setEquipmentServiceReplicateSelected] = useState({});
  const [accountableName, setAccountableName] = useState("");
  const [scheduledServiceDate, setScheduledServiceDate] = useState(null);
  const [scheduledServiceId, setScheduledServiceId] = useState("");

  const [servicesTabValue, setServicesTabValue] = useState(0);
  const [draftsPage, setDraftsPage] = useState(1);
  const [draftsLimit, setDraftsLimit] = useState(10);
  const [showServiceCreationBlockedModal, setShowServiceCreationBlockedModal] = useState(false);

  const services = useSelector(state => state.services.servicesByEquipment);
  const equipment = useSelector(state => state.equipments.equipment);
  const loadingServices = useSelector(state => state.services.loading);
  const loadingMoreServices = useSelector(state => state.services.loadingMoreServicesByEquipment);
  const loadingEquipments = useSelector(state => state.equipments.loading);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);

  const serviceDrafts = useSelector(state => state.equipments.serviceDrafts || []);
  const serviceDraftsCount = useSelector(state => state.equipments.serviceDraftsCount);
  const serviceDraftsLoading = useSelector(state => state.equipments.serviceDraftsLoading);
  const deleteDraftLoading = useSelector(state => state.equipments.deleteServiceDraftLoading);
  const deletingDraftId = useSelector(state => state.equipments.deleteServiceDraftId);

  const isAnalyst = selectedAccess.role === EAccessRole.analyst;
  const isContractor = selectedAccess.role === EAccessRole.contractor;
  const isInspector = selectedAccess.inspector && (isAnalyst || isContractor);
  const onlyQRServicesFeatureFlag = selectedAccess.tenant.featureFlags.includes(EFeatureFlags.BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING);
  const blockServiceCreation = (onlyQRServicesFeatureFlag && (isAnalyst || isContractor));

  const fetchEquipmentById = useCallback(
    () => dispatch(actions.fetchEquipmentsByIdWithServicesReplicate(equipId)),
    [equipId]
  );

  const fetchServicesByEquipment = useCallback(
    (shouldFetchMoreData = false) => dispatch(actions.fetchServicesByEquipment(equipId, page, limit, order, orderBy, selectedServiceTypes, shouldFetchMoreData)),
    [equipId, page, limit, order, orderBy, selectedServiceTypes]
  );

  

  const servicesIds =  equipment?.equipmentServicesReplicate?.map(s => s.serviceId) || [];
  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  const fetchEquipmentServicesReplicatedZip = useCallback(
    () => dispatch(actions.fetchEquipmentServicesReplicatedZip(servicesIds, emailLanguage)),
    [servicesIds]
  );

  const fetchEquipmentServicesReplicatedDataExport = useCallback(
    (dataExportType) => dispatch(actions.fetchEquipmentServicesReplicatedDataExport([equipId], dataExportType, emailLanguage)),
    [equipId]
  );

  const fetchEquipmentServicesSimplified = useCallback(
    () => dispatch(actions.fetchEquipmentServicesSimplified(equipId)),
    [equipId]
  );


  const menuItems = [
    // {
    //   label: i18n.t('typographyformEquipServ.zipExport'),
    //   onClick: () => fetchEquipmentServicesReplicatedZip(),
    //   disabled: loadingZip,
    //   loading: loadingZip,
    //   icon: <PrintIcon />
    // },
    {
      label: i18n.t('typographyformEquipServ.allEquipmentServicesReplicateExportPDF'),
      onClick: () => fetchEquipmentServicesReplicatedDataExport(EDataExportsType.equipmentReplicatedServicesReport),
      disabled: loadingZip,
      loading: loadingZip,
      icon: <PrintIcon />
    },
    {
      label: i18n.t('typographyformEquipServ.simplifiedExport'),
      onClick: () => fetchEquipmentServicesSimplified(),
      disabled: loadingSimplified,
      loading: loadingSimplified,
      icon: <PrintIcon />
    },
    {
      label: i18n.t('typographyformEquipServ.allEquipmentServicesReplicateWithAttachmentsExportZip'),
      onClick: () => fetchEquipmentServicesReplicatedDataExport(EDataExportsType.equipmentReplicatedServicesWithAttachmentsReport),
      disabled: loadingZip,
      loading: loadingZip,
      icon: <PrintIcon />
    },
  ];

  // get from redux


  useEffect(() => {
    fetchEquipmentById();
  }, []);

  // Filtro alterado (ou primeira carga): nova query a partir da página 1, igual às tabelas.
  useEffect(() => {
    fetchServicesByEquipment();
  }, [equipId, selectedServiceTypes, order, orderBy]);

  // Lista infinita: páginas seguintes fazem append no que já está carregado.
  useEffect(() => {
    if (page > 1) fetchServicesByEquipment(true);
  }, [page]);

  useEffect(() => {
    if ( equipId) dispatch(actions.equipmentFetchServiceDraftsByEquipment(equipId, draftsPage, draftsLimit));
  }, [ equipId, draftsPage, draftsLimit])

  const handleClickChip = (id) => {
    setPage(1);
    setSelectedServiceTypes(prevState => {
      if (prevState.indexOf(id) === -1) {
        return ([...prevState, id]);
      }
      return prevState.filter(i => i !== id);
    })
  }
  const handleClickChecklist = async (id) => {
    const equipServices = await equipment.equipmentModel.equipmentServices.find(eqService => eqService._id === id)
    const inspection = `${equipServices.serviceType.name} ${equipServices.frequency.name}`

    const groupArray = [];
    equipServices.questions.map(question => {
      if(question.type === 'group') {
        question.questionArray = [];
        extractPositionFromName(question)
        groupArray.push(question)
    }
    })

    const groupArrayOrdered = groupArray.sort(orderQuestionArray)

    equipServices.questions.forEach(question => {
      if (question.type === 'question') {
        let index;
        extractPositionFromName(question)
        index = groupArrayOrdered.findIndex(ga => ga.name === question.groupName);
        if(index > -1) {
            groupArrayOrdered[index].questionArray.push(question)
        }
      }
    });

    const checklist = await equipServices.questions.sort(orderQuestionArray).filter(question => question.site === equipment.site);
    setModalContent({ inspection, checklist, equipServiceId: id, equipId, site: equipment.site  })
    setOpenModal(true);
  }

  const handleClickAddService = () => {
    if (blockServiceCreation) {
      setShowServiceCreationBlockedModal(true);
    } else {
      props.history.push("/form-new-service/1");
      dispatch(actions.createServiceSelectEquipment(equipId));
    }
  }

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalContent();
  }

  const handleGoToEquipmentServiceScreen = (equipmentService) => {
    if (blockServiceCreation) {
      setShowServiceCreationBlockedModal(true);
    } else {
      dispatch(actions.createServiceSetServiceDraftId(''));
      dispatch(actions.createServiceSelectEquipment(equipId));
      dispatch(actions.createServiceFetchEquipmentServices(equipId));
      dispatch(actions.createServiceSelectEquipmentService(equipmentService));
      props.history.push("/form-new-service/2");
    }
  }

  console.log('blockServiceCreation', blockServiceCreation);

  const hasScheduledServicesFeatureFlag = checkFeatureFlag({ featureFlags: tenant.featureFlags, featureFlagToCheck: EFeatureFlags.SCHEDULED_SERVICES });

  const handleEquipmentServices = (serv) => {
    const service = equipment.equipmentServicesReplicate && equipment.equipmentServicesReplicate.find(s => s.equipmentServiceId === serv._id);
    const scheduledService = equipment.scheduledServicesReplicated && equipment.scheduledServicesReplicated.find(s => s.equipmentServiceId === serv._id);
    let label = '';
    let note = '';
    let noteFunction = () => '';

    const status = (service && service.situation) ? service.situation.status : '';

    if (!service) {
      label = i18n.t('divFromEquipService.noServices');
      note = i18n.t('typographyformEquipServ.notDone');
    } else if (status === 'onDemand') {
      label = i18n.t('divFromEquipService.onDemand');
    } else if (status === 'noServices') {
      label = i18n.t('divFromEquipService.noServices');
    } else if (status === 'lastDay') {
      label = i18n.t('divFromEquipService.lastDay');
    } else if (status === 'remaining') {
      const translateFunction = i18n.t('divFromEquipService.remaining');
      label = translateFunction(new Date(service.expirationDate).toLocaleDateString('PT-br'), service.situation.days);
    } else if (status === 'inDelay') {
      const translateFunction = i18n.t('divFromEquipService.inDelay');
      label = translateFunction(new Date(service.expirationDate).toLocaleDateString('PT-br'), service.situation.days);
    }

    if (service && !service.status && service.note && service.note.hasActionsOpenedOrOverdue > 0) {
      noteFunction = i18n.t('typographyformEquipServ.hasActionsOpenedOrOverdue');
      note = noteFunction(service.note.hasActionsOpenedOrOverdue);
    }
    
    if (service && !service.status && service.note && service.note.inDelay > 0) {
      noteFunction = i18n.t('typographyformEquipServ.inDelay');
      note = noteFunction(service.note.inDelay);
    }
    
    if (service?.status && service.note?.hasActionsOpenedOrOverdue > 0) {
      noteFunction = i18n.t('typographyformEquipServ.hasActionsOpenedOrOverdue');
      note = noteFunction(service.note.hasActionsOpenedOrOverdue);
    }

    return (
      <>
        <Box key={serv._id} sx={{ display: 'flex', flexDirection: 'column', padding: '0.25rem 0' }} >
          <Box sx={{ display: 'flex', alignItems: 'center' }} >
            <Box sx={{cursor: 'pointer', ':hover': {textDecoration: 'underline'}}} onClick={() => handleGoToEquipmentServiceScreen(serv)}>
              {serv.serviceType.name}
              {' '}
              {serv.frequency.name}
            </Box>
            <div
              onClick={() => handleClickChecklist(serv._id)}
              style={{ marginLeft: '1rem', textDecoration: 'underline', cursor: 'pointer', fontSize: '0.7rem' }}
            >
              checklist
            </div>
            { serv.mandatory &&
              <div style={{ marginLeft: '1rem', backgroundColor: '#808080', fontSize: '0.7rem', padding: '0.25rem', border: '5px', borderRadius: '5px'}}>
                { i18n.t('divFromEquipService.mandatory') }
              </div>
            }
          </Box>
          <div style={styles.subtitle}>
            { label }
          </div>
          {scheduledService && scheduledService.scheduledServiceAccountablesNames && scheduledService.scheduledDate && 
            <Box style={{ display: 'flex', flexDirection: 'column'}}>
              <Typography style={styles.subtitle}>
                {`${i18n.t('divFromEquipService.scheduledTo')} ${scheduledService.scheduledServiceAccountablesNames}`}
              </Typography>
              <Typography style={styles.subtitle}>
                {`${i18n.t('divFromEquipService.scheduledDate')} ${moment(scheduledService.scheduledDate).format('DD/MMM/YYYY')}`}
              </Typography>
            </Box>
          }
          { service?.note?.hasActionsOpenedOrOverdue > 0 &&
            <Box sx={styles.subtitle}>
              { i18n.t('divFromEquipService.haveOpenedActions')(service.note.hasActionsOpenedOrOverdue) }
            </Box>
          }
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center'}}>
          { (hasScheduledServicesFeatureFlag && scheduledService && !isInspector) &&
            <Button
              variant='text'
              size='small'
              sx={{maxWidth: '150px', color: 'rgba(76, 175, 80, 1)', padding: '3px 7px', borderRadius: '8px', marginRight: '10px'}}
              startIcon={<CalendarTodayIcon />}
              onClick={() => {
                setServiceName(`${serv.serviceType.name} ${serv.frequency.name}`);
                setAccountableName(scheduledService.scheduledServiceAccountablesNames);
                setScheduledServiceDate(scheduledService.scheduledDate);
                setScheduledServiceId(scheduledService.scheduledServiceId || "")
                setScheduledServiceModalOpen(true);
                setEquipmentServiceReplicateSelected({
                  expirationDate: service?.expirationDate || null,
                  equipmentServiceId: serv,
                });
              }}
            >
              {i18n.t('calendarServiceCard.schedule')}
            </Button>
          }
          {service?.status && service?.note?.hasActionsOpenedOrOverdue === 0 && <CheckCircleRounded style={{ color: '#6bbd6b' }} />}
          {service?.status && service?.note?.hasActionsOpenedOrOverdue > 0 &&
            <Tooltip title={
              <>
                <Typography variant='caption' color="inherit">
                  { note }
                </Typography>
                <div>&nbsp;</div>
              </>
            }>
              <CheckCircleRounded style={{ color: '#6bbd6b' }} />
            </Tooltip>
          }
          {((service && !service.status) || !service) &&
            <Tooltip title={
              <>
                <Typography variant='caption' color="inherit">
                  { note }
                </Typography>
                <div>&nbsp;</div>
              </>
            }>
              <CancelRounded style={{ color: "#e57878" }} />
            </Tooltip>
          }
          {service?.note?.hasActionsOpenedOrOverdue > 0 && <SendIcon style={styles.warningIcon} />}
        </Box>
      </>
    )
  }

  const loadMoreServices = () => {
    setPage(prev => prev + 1);
  };

  const handleClickService = (service_id) => {
    props.history.push(`/form-edit-service/${service_id}`);
  };

  const handleFinalizeDraft = (draft) => {
    const equipmentId = draft.equipment?._id;
    dispatch(actions.createServiceSetServiceDraftId(draft._id));
    dispatch(actions.createServiceSelectEquipment(equipmentId));
    dispatch(actions.createServiceFetchEquipmentServices(equipmentId));
    dispatch(actions.createServiceSelectEquipmentService(draft.equipmentService));
    props.history.push("/form-new-service/2", { from: props.location.pathname });
  };

  const handleDeleteDraft = (draftId) => {
    confirm(i18n.t('tableServiceDrafts.deleteDraftMessage'), {
      title: i18n.t('tableServiceDrafts.deleteDraftTitle'),
      titleColor: 'red',
      disableBackdrop: true
    }).then(
      () => {},
      () => dispatch(actions.equipmentDeleteServiceDraft(draftId, draftsPage, draftsLimit, equipId))
    );
  };

  const activeEquipmentServices = equipment?.equipmentModel?.equipmentServices || [];
  const inactiveEquipmentServices = equipment?.equipmentModel?.inactiveEquipmentServices || [];

  return (
    <>
      <Tabs {...props} selected={'servicesTab'} />
      <div style={matches ? styles.divContainer : styles.divContainerSmall}>
        <Container maxWidth='md' style={styles.container}>
          <Paper style={{ ...styles.paper, backgroundColor: '#e7e7e7' }}>
            {loadingEquipments && <Spinner overlay />}
            <FormStyled onSubmit={() => { }} style={{ opacity: loadingEquipments ? '0.3' : '1' }}>
              <DivFormTitle>
                <Typography variant='h6' style={{ padding: '0.5rem 0', fontWeight: 'bold' }}>{i18n.t('typographyformEquipServ.text2')}</Typography>
                <ButtonDropdown
                  label={i18n.t('fileDownloadButtonCompCalendar.title')}
                  disabled={loadingEquipments}
                  menuItems={menuItems}
                  loading={false}
                />
              </DivFormTitle>
              <Divider />
              <div style={styles.formContent}>
                {equipment.equipmentModel && sortBy(equipment.equipmentModel.equipmentServices, ['serviceType.name', 'frequency.name']).map((serv, ind) => {
                  return (
                    <div key={serv._id}>
                      <div style={styles.listItem}>
                        {handleEquipmentServices(serv)}
                      </div>
                      {(equipment.equipmentModel.equipmentServices.length - 1) !== ind && <Divider />}
                    </div>
                  )
                })}
              </div>
            </FormStyled>
          </Paper>
          <Paper style={styles.paper}>
            {(loadingServices || (servicesTabValue === 1 && serviceDraftsLoading)) && <Spinner overlay />}
            <FormStyled onSubmit={() => { }} style={{ opacity: (loadingServices || (servicesTabValue === 1 && serviceDraftsLoading)) ? '0.3' : '1' }}>
              <DivFormTitle>
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, marginBottom: '10px', justifyContent: 'space-between', width: '100%' }}>
                  <TabsMui
                    value={servicesTabValue}
                    onChange={(e, tabvalue) => setServicesTabValue(tabvalue)}
                    sx={{
                      minHeight: 40,
                      '& .MuiTab-root': { minHeight: 40, textTransform: 'none', fontWeight: 600, fontSize: '0.875rem' },
                      '& .Mui-selected': { backgroundColor: 'rgba(76, 175, 80, 0.2)', borderRadius: '4px 4px 0 0' },
                    }}
                  >
                    <Tab label={i18n.t('typographyformEquipServ.servicesCompletedTab').toUpperCase()} />
                    <Tab label={i18n.t('typographyformEquipServ.draftsTab').toUpperCase()} />
                  </TabsMui>
                  <Button
                    style={styles.buttonAdd}
                    variant='outlined'
                    aria-label="add"
                    onClick={handleClickAddService}
                    startIcon={<AddCircleOutline />}
                    sx={{ marginLeft: 'auto' }}
                  >
                    {i18n.t('btnFormEquip.text')}
                  </Button>
                </Box>
              </DivFormTitle>
              <Divider />
              <div style={styles.formContent}>
                {servicesTabValue === 0 && (
                  <>
                    {!loadingServices && services.rows.length === 0 && selectedServiceTypes.length === 0 &&
                      <div style={styles.servicesNotFound}>{i18n.t('divFromEquipService.noFound')}</div>}
                    {!loadingServices && (services.rows.length > 0 || selectedServiceTypes.length > 0) &&
                      <div style={styles.chipContainer}>
                        {equipment.equipmentModel && sortBy([...activeEquipmentServices.map(equipServ => ({...equipServ, active: true})), ...inactiveEquipmentServices.map(equipServ => ({...equipServ, active: false}))], ['serviceType.name', 'frequency.name']).map(serv => (
                          <Chip
                            key={serv._id}
                            onClick={() => handleClickChip(serv._id)}
                            clickable
                            variant="outlined"
                            label={`${serv.serviceType.name} ${serv.frequency.name} ${serv.active ? '' : '(' + i18n.t('divFromEquipService.inactive') + ')'}`}
                            style={{
                              ...styles.chip,
                              backgroundColor: selectedServiceTypes.indexOf(serv._id) === -1 ? '#fff' : '#ccc',
                            }}
                          />
                        ))}
                      </div>}
                    {!loadingServices && services.rows.length === 0 && selectedServiceTypes.length > 0 &&
                      <div style={styles.servicesNotFound}>{i18n.t('divFromEquipService.noFound')}</div>}
                    <Timeline data={services.rows} spinner={loadingServices} handleAction={handleClickService} />
                    {!loadingServices && (
                      <Box style={styles.loadMoreBox}>
                        {loadingMoreServices && <CircularProgress size={30} />}
                        {!loadingMoreServices && services.rows.length < services.count &&
                          <Button onClick={loadMoreServices} variant='outlined'>
                            {i18n.t('divFromEquipService.loadMore')}
                          </Button>}
                      </Box>
                    )}
                  </>
                )}
                {servicesTabValue === 1 && (
                  <>
                    {!serviceDraftsLoading && serviceDrafts.length === 0 &&
                      <div style={styles.servicesNotFound}>{i18n.t('divFromEquipService.noFound')}</div>}
                    {serviceDrafts.length > 0 && (
                      <>
                        <Table size="small" sx={{ marginTop: 1 }}>
                          <TableBody>
                            {serviceDrafts.map((draft) => (
                              <TableRow key={draft._id} hover sx={{ '&:last-child td': { border: 0 } }}>
                                <TableCell sx={{ verticalAlign: 'top', padding: '12px 8px' }}>
                                  <Typography variant="body2" fontWeight={500}>
                                    {(draft.serviceType?.name || '') + ' ' + (draft.frequency?.name || '')}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {i18n.t('typographyformEquipServ.draftStartedAt')} {moment(draft.startedAt || draft.createdAt).format('DD/MM/YYYY HH:mm')}
                                  </Typography>
                                </TableCell>
                                <TableCell align="right" sx={{ padding: '12px 8px', whiteSpace: 'nowrap' }}>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    sx={{ color: 'rgba(29, 127, 76, 1)', borderColor: 'rgba(29, 127, 76, 1)', marginRight: 0.5 }}
                                    onClick={() => handleFinalizeDraft(draft)}
                                    disabled={deleteDraftLoading}
                                  >
                                    {i18n.t('tableServiceDrafts.finishService')}
                                  </Button>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDeleteDraft(draft._id)}
                                    disabled={deleteDraftLoading}
                                    aria-label="delete"
                                  >
                                    {(deleteDraftLoading && deletingDraftId === draft._id) ? <CircularProgress size={18} /> : <DeleteIcon fontSize="small" />}
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                          <TableFooter>
                            <TableRow>
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                count={serviceDraftsCount}
                                rowsPerPage={draftsLimit}
                                page={draftsPage - 1}
                                onPageChange={(e, newPage) => setDraftsPage(newPage + 1)}
                                onRowsPerPageChange={(e) => { setDraftsLimit(parseInt(e.target.value, 10)); setDraftsPage(1); }}
                                SelectProps={{ native: true }}
                                ActionsComponent={TablePaginationActionsWrapped}
                              />
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </>
                    )}
                  </>
                )}
              </div>
            </FormStyled>
          </Paper>
        </Container>
      </div>
      <Dialog
        scroll='body'
        fullWidth
        maxWidth="md"
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            overflow: 'visible'
          },
        }}
      >
        <ModalEquipmentChecklist
          closeModal={handleCloseModal}
          modalContent={modalContent}
        />
      </Dialog>
      <Dialog
        onClose={() => setScheduledServiceModalOpen(false)}
        open={scheduledServiceModalOpen}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <ScheduleServiceModal
          equipment={equipment}
          equipmentServicesReplicate={equipmentServiceReplicateSelected}
          backPage=''
          serviceName={serviceName}
          scheduledDate={scheduledServiceDate}
          accountableId={""}
          accountableName={accountableName}
          scheduledServiceId={scheduledServiceId}
          closeModal={() => setScheduledServiceModalOpen(false)}
          fetchData={() => fetchEquipmentById()}
        />

      </Dialog>
      <ServiceCreationBlockedModal
        show={showServiceCreationBlockedModal}
        close={() => setShowServiceCreationBlockedModal(false)}
      />

    </>
  )
}

export default FormEquipments;
